import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import Moon from "@/components/Moon";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-[#06080d]" data-testid="auth-loading">
        <Moon size={90} />
        <p className="mt-8 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">Loading your sky…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
